import "./TemplateLibraryViewPage.css";

import { Card, CardContent, Grid } from "../../common/MaterialComponent";

import React from "react";
import TemplateCard from "./TemplateCard/TemplateCard";
import { useGetComponentStringsContext } from "../../hooks/useGetComponentStrings";
import { useHistory } from "react-router-dom";

export const TemplateLibraryViewPage: React.FC = () => {
	const strings = useGetComponentStringsContext().TemplateLibraryViewPage;
	const history = useHistory();

	return (
		<div className="templateLibraryViewPageContainer">
			<>
				<Card elevation={1}>
					<CardContent>
						{/* <Typography
							variant="h6"
							noWrap
							color="textSecondary"
							className="containerTitle"
						>
							<b>{strings.titleMessage}</b>
						</Typography> */}
						<Grid
							container
							spacing={3}
							justify="center"
							alignItems="center"
							className="cardGrid"
						>
							<Grid item xs={12} md={3}>
								<TemplateCard
									header={strings.batchMessageCardHeader}
									body={strings.batchMessageCardBody}
									cardButtonText={strings.createButtonText}
									cardButtonAction={() => {
										history.push({
											pathname: "/batchMessageConfiguration",
											state: {
												requestFromPath: "templateLibraryView",
											},
										});
									}}
									disableCardButton={false}
								/>
							</Grid>
							<Grid item xs={12} md={1}></Grid>
							{/* <Grid item xs={12} md={3}>
								<TemplateCard
									header={strings.requestForHelpCardHeader}
									body={strings.requestForHelpCardBody}
									cardButtonText={strings.createButtonText}
									cardButtonAction={() => {
										history.push({
											pathname: "/requestForHelpConfiguration",
											state: {
												requestFromPath: "templateLibraryView",
											},
										});
									}}
									disableCardButton={false}
								/>
							</Grid> */}
						</Grid>
					</CardContent>
				</Card>
			</>
		</div>
	);
};
